import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import authService from './services/auth.service';
import Members from './views/Members.vue';
import Families from './views/Families.vue';
import Family from './views/Family.vue';
import FamilyEdit from './views/FamilyEdit.vue';
import Reporting from './views/Reporting.vue';
import ReportingEmailAll from './views/ReportingEmailAll.vue';
import ReportingEmailNewsletter from './views/ReportingEmailNewsletter.vue';
import ReportingEmailNeighbourhood from './views/ReportingEmailNeighbourhood.vue';
import ReportingEmailNotNeighbourhood from './views/ReportingEmailNotNeighbourhood.vue';
import Register from './views/Register.vue';
import Login from './views/Login.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Members',
    meta: { requiresAuth: true },
    component: Members,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/family/:key/edit',
    name: 'Family Edit',
    meta: { requiresAuth: true },
    component: FamilyEdit,
  },
  {
    path: '/new-family/',
    name: 'New Family',
    meta: { requiresAuth: true },
    component: FamilyEdit,
  },
  {
    path: '/family/:key',
    name: 'Family',
    meta: { requiresAuth: true },
    component: Family,
  },
  {
    path: '/family',
    name: 'Families',
    meta: { requiresAuth: true },
    component: Families,
  },
  {
    path: '/reporting/count',
    name: 'Reportage',
    meta: { requiresAuth: true },
    component: Reporting,
  },
  {
    path: '/reporting/email-all',
    name: 'Reportage Email All',
    meta: { requiresAuth: true },
    component: ReportingEmailAll,
  },
  {
    path: '/reporting/email-newsletter',
    name: 'Reportage Email Nieuwsbrief',
    meta: { requiresAuth: true },
    component: ReportingEmailNewsletter,
  },
  {
    path: '/reporting/email-neighbourhood',
    name: 'Reportage Email Buurt',
    meta: { requiresAuth: true },
    component: ReportingEmailNeighbourhood,
  },
  {
    path: '/reporting/email-not-neighbourhood',
    name: 'Reportage Email Niet Buurt',
    meta: { requiresAuth: true },
    component: ReportingEmailNotNeighbourhood,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/logout',
    redirect: '/login',
  },
  {
    path: '/upload',
    name: 'Upload',
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "upload" */ './views/Upload.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, _, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    await authService.update();

    if (!authService.isLoggedIn()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
